import { HStack, Link } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { Icon } from "@shared/ui/chakra/data-display/icon";
import { Typography } from "@shared/ui/chakra/typography/typography";

import { contactHelpMessages } from "./messages";

type Props = {
  email: string;
  onClick?: () => void;
};

export const HelpBox = ({ onClick }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <HStack cursor="pointer" onClick={onClick}>
      <Link
        backgroundColor="whiteAlpha.0"
        borderRadius="full"
        display="inline-flex"
        href="https://t.me/Mainex_kg"
        outline="none"
        p="10px 16px"
        rel="noopener noreferrer"
        target="_blank"
        textDecoration="none"
      >
        <Icon name="Support" />
        <Typography color="text.fg" textStyle="label">
          {formatMessage(contactHelpMessages.title)}
        </Typography>
      </Link>
    </HStack>
  );
};
